import { render, staticRenderFns } from "./DepartmentEdit.vue?vue&type=template&id=4f596945&scoped=true"
import script from "./DepartmentEdit.vue?vue&type=script&lang=js"
export * from "./DepartmentEdit.vue?vue&type=script&lang=js"
import style0 from "./DepartmentEdit.vue?vue&type=style&index=0&id=4f596945&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f596945",
  null
  
)

export default component.exports